module.exports = __webpack_public_path__ + "static/media/stepper-complete-icon.35a15ed7.svg";